/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateRealEstateCommandDto } from './CreateRealEstateCommandDto';
import {
    CreateRealEstateCommandDtoFromJSON,
    CreateRealEstateCommandDtoFromJSONTyped,
    CreateRealEstateCommandDtoToJSON,
    CreateRealEstateCommandDtoToJSONTyped,
} from './CreateRealEstateCommandDto';
import type { SaveAnswerCommandDto } from './SaveAnswerCommandDto';
import {
    SaveAnswerCommandDtoFromJSON,
    SaveAnswerCommandDtoFromJSONTyped,
    SaveAnswerCommandDtoToJSON,
    SaveAnswerCommandDtoToJSONTyped,
} from './SaveAnswerCommandDto';

/**
 * 
 * @export
 * @interface CreateRealEstateWithQuestionsCommandDto
 */
export interface CreateRealEstateWithQuestionsCommandDto {
    /**
     * 
     * @type {CreateRealEstateCommandDto}
     * @memberof CreateRealEstateWithQuestionsCommandDto
     */
    createRealEstateCommand: CreateRealEstateCommandDto;
    /**
     * 
     * @type {SaveAnswerCommandDto}
     * @memberof CreateRealEstateWithQuestionsCommandDto
     */
    saveAnswersCommand: SaveAnswerCommandDto;
}

/**
 * Check if a given object implements the CreateRealEstateWithQuestionsCommandDto interface.
 */
export function instanceOfCreateRealEstateWithQuestionsCommandDto(value: object): value is CreateRealEstateWithQuestionsCommandDto {
    if (!('createRealEstateCommand' in value) || value['createRealEstateCommand'] === undefined) return false;
    if (!('saveAnswersCommand' in value) || value['saveAnswersCommand'] === undefined) return false;
    return true;
}

export function CreateRealEstateWithQuestionsCommandDtoFromJSON(json: any): CreateRealEstateWithQuestionsCommandDto {
    return CreateRealEstateWithQuestionsCommandDtoFromJSONTyped(json, false);
}

export function CreateRealEstateWithQuestionsCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRealEstateWithQuestionsCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createRealEstateCommand': CreateRealEstateCommandDtoFromJSON(json['createRealEstateCommand']),
        'saveAnswersCommand': SaveAnswerCommandDtoFromJSON(json['saveAnswersCommand']),
    };
}

export function CreateRealEstateWithQuestionsCommandDtoToJSON(json: any): CreateRealEstateWithQuestionsCommandDto {
    return CreateRealEstateWithQuestionsCommandDtoToJSONTyped(json, false);
}

export function CreateRealEstateWithQuestionsCommandDtoToJSONTyped(value?: CreateRealEstateWithQuestionsCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createRealEstateCommand': CreateRealEstateCommandDtoToJSON(value['createRealEstateCommand']),
        'saveAnswersCommand': SaveAnswerCommandDtoToJSON(value['saveAnswersCommand']),
    };
}

